import { Checkbox, colors, FormControl, FormHelperText, IconButton, ListItemText, MenuItem, Select, Typography } from '@mui/material'
import { Star, StarBorder } from '@mui/icons-material'
import React from 'react'

function CustomDropDown({ title, errMsg, handleDDChange, name, ddArr, width, height, defaultValue, bgColor, fontSize, multiple, value, placeholder, onToggleFav }) {
    const labelStyle = {
        color: errMsg && colors.red[500],
        fontWeight: "600",
        fontSize: fontSize || 16
    }

    if (multiple) {
        const selected = Array.isArray(value) ? value : [];
        return (
            <FormControl sx={{ width: width ? width : 500 }} fullWidth>
                {title && <Typography htmlFor={"dd-id"} style={labelStyle} component={'label'} sx={{ mb: 0.7 }}>{title}</Typography>}
                <Select
                    multiple
                    onChange={handleDDChange}
                    displayEmpty
                    inputProps={{ 'aria-label': 'Without label' }}
                    id="dd-id"
                    value={selected}
                    name={name}
                    renderValue={(sel) => sel.length === 0
                        ? <em>{placeholder || "All"}</em>
                        : (sel.join(', ').length > 40 ? `${sel.length} selected` : sel.join(', '))}
                    sx={{ height: height ? height : 45, backgroundColor: bgColor, fontSize: fontSize || 16 }}
                    MenuProps={{ PaperProps: { style: { maxHeight: 320 } } }}
                >
                    {ddArr.map((i) => {
                        const v = i.value || i.id;
                        return (
                            <MenuItem value={v} key={v} dense>
                                <Checkbox size='small' checked={selected.indexOf(v) > -1} sx={{ py: 0 }} />
                                <ListItemText primary={i.label || i.configName} primaryTypographyProps={{ fontSize: fontSize || 15 }} />
                            </MenuItem>
                        )
                    })}
                </Select>
                <FormHelperText style={{ color: colors.red[500], }}>{errMsg}</FormHelperText>
            </FormControl>
        )
    }

    return (

        <FormControl sx={{ width: width ? width : 500 }} fullWidth>
            {title && <Typography htmlFor={"dd-id"} style={labelStyle} component={'label'} sx={{ mb: 0.7 }}>{title}</Typography>}
            <Select
                onChange={handleDDChange}
                displayEmpty
                inputProps={{ 'aria-label': 'Without label' }}
                id="dd-id"
                defaultValue={defaultValue ? defaultValue : ""}
                name={name}
                sx={{ height: height ? height : 45, backgroundColor: bgColor, fontSize: fontSize || 16 }}
            >
                <MenuItem value=""><em>None</em></MenuItem>
                {ddArr.map((i) =>
                    <MenuItem value={i.value || i.id} key={i.value || i.id}
                        sx={onToggleFav ? { display: 'flex', justifyContent: 'space-between', alignItems: 'center' } : undefined}>
                        {i.label || i.configName}
                        {onToggleFav && i.value !== "Others" &&
                            <IconButton size="small" sx={{ ml: 1, p: 0.25 }}
                                onMouseDown={(e) => e.stopPropagation()}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    e.preventDefault();
                                    onToggleFav(i.value || i.id);
                                }}>
                                {i.isFav ? <Star fontSize="small" sx={{ color: "#f5b301" }} /> : <StarBorder fontSize="small" color="action" />}
                            </IconButton>}
                    </MenuItem>)}
            </Select>
            <FormHelperText style={{ color: colors.red[500], }}>{errMsg}</FormHelperText>
        </FormControl>
    )
}

export default CustomDropDown